<template>
<v-container fluid class="pa-0" style="height: 100vh; background: #53aafb; background-image: url(https://wordpress.trackier.com/wp-content/uploads/2020/07/map.png);">
    <div class="w-h-50" style="background: #eff6fe; background-image: url(https://wordpress.trackier.com/wp-content/uploads/2020/07/map.png);"></div>
    <div class="login-card-p">
        <v-card width="100%" flat class="zoom-90" style="border-radius: 1rem !important">
            <v-row>
                <v-col cols="12" md="6" class="pa-6 pb-0">
                    <v-card-text class="py-0 mb-4 px-md-12">
                        <v-img width="150" class="mt-4 mx-auto" src="/images/logo1.png" lazy-src="/images/logo1.png" aspect-ratio="4" contain>
                            <template v-slot:placeholder>
                                <v-row class="fill-height ma-0" align="center" justify="center">
                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                </v-row>
                            </template>
                        </v-img>
                        <div class="px-md-10">
                            <h3 class="headline font-weight-light mt-4 mb-4 text-center" value="tab-1">{{$route.params.id == 'login' ? 'Welcome Back' : $route.params.id == 'register' ? 'Create Account' : 'Forget your password?' }}</h3>
                            <br>
                            <!-- <div v-if="$route.params.id != 'forget-password'">
                                <h1 class="text-center mb-5">
                                    <v-btn block class="mb-6 white pa-5 box-shadow-custom-1">
                                        <img width="20" src="https://cdn.zapier.com/storage/photos/98dfdf3827082a15da731db63938da96.png" alt="">
                                        <span class="ml-4 font-weight-bold text-capitalize grey--text text--darken-2">{{$route.params.id == 'login' ? 'Sign in with Google' : 'Sign up with Google'}}</span>
                                    </v-btn>
                                </h1>
                                <br>
                            </div> -->
                            <v-divider></v-divider>
                            <p style="margin-top: -10px; text-align: center;"><span class="pa-2 white caption grey--text">{{$route.params.id == 'login' ? 'OR LOGIN WITH EMAIL' : $route.params.id == 'register' ? 'Be part of OffersOptimize and start testing your links today.' : "Don't worry. Resetting your password is easy, just tell us the email address you registered." }}</span></p>
                            <br>
                        </div>
                        <v-skeleton-loader v-if="$route.params.id == 'login'" :loading="loading" height="250" type="list-item, list-item, list-item, list-item-two-line">
                            <Login />
                        </v-skeleton-loader>
                        <v-skeleton-loader v-if="$route.params.id == 'register'" :loading="loading" height="250" type="list-item, list-item, list-item, list-item-two-line">
                            <Register />
                        </v-skeleton-loader>
                        <v-skeleton-loader v-if="$route.params.id == 'forget-password'" :loading="loading" height="250" type="list-item, list-item-two-line">
                            <Forget />
                        </v-skeleton-loader>
                    </v-card-text>
                </v-col>
                <v-col cols="6" class="login-img d-none d-sm-none d-md-inline-flex" :style="`background: ${$route.params.id != 'forget-password' ? 'rgb(235 243 250)' : '#ffffff'}`">
                    <div class="d-flex justify-center align-center" style="width: 100%;">
                        <v-card-text>
                            <v-img :src="`${$route.params.id != 'forget-password' ? '/images/login-image.png' : '/images/password.jpg' }`" :lazy-src="`${$route.params.id != 'forget-password' ? '/images/login-image.png' : '/images/password.jpg' }`" aspect-ratio="1.5" contain>
                                <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                        </v-card-text>
                    </div>
                </v-col>
            </v-row>
        </v-card>
    </div>
</v-container>
</template>

<script>
import {
    mapGetters
} from 'vuex'
export default {
    components: {
        Register: () => import('@/components/Auth/Register'),
        Login: () => import('@/components/Auth/Login'),
        Forget: () => import('@/components/Auth/Forget-password')

    },
    data: () => ({
        loading: true
    }),
    mounted() {
        setInterval(() => {
            this.loading = false
        }, 500);
        if (this.$route.params.id != 'forget-password' && this.$route.params.id != 'login' && this.$route.params.id != 'register') {
            this.$router.push('/error/404')
        }
    }

}
</script>
<style scope>
    .w-h-50{
        width: 50%;
        height: inherit;
    }
    .login-card-p{
        position: absolute;
        top: 0;
        left: 15%;
        right: 15%;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;

    }
    @media only screen and (max-width: 600px) {
        .login-card-p{
            left: 2%;
            right: 2%;
        }
    }
    .login-img{
        border-top-right-radius: 1rem; 
        border-bottom-right-radius: 1rem;
        display: inherit;
    }
</style>
